import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { Permission } from "../../common/enums/permission.enum";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from "../../shared/services/cache.service";
@Pipe({
    name: 'hasAccess'
})

@Injectable()
export class AuthorizationExtensionPipe implements PipeTransform {
constructor(private _cacheService:CacheService){}
    transform(value: any, resourceTypeId?: Number, resourceId?: Number): Boolean {

      if (value instanceof Array) {
       const userInfo:UserInfo = this._cacheService.get(CacheKey.UserInfo);
      if (userInfo && userInfo.hasSystemRole) {
        return true;
      }
      else if (resourceTypeId && resourceId && userInfo && resourceTypeId===AccessLevel.Store && resourceId > 0) {
        let manageStorePermissions: Number[] = [Permission.MANAGE_STORE_CREATE, Permission.MANAGE_STORE_VIEW, Permission.MANAGE_STORE_EDIT, Permission.MANAGE_STORE_DELETE];
        let userStorePermissions: any[] = userInfo.privileges.stores;
        let userAccountPermissions: any[] = userInfo.privileges.account;
        if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => value.indexOf(item) >= 0)) {
          return true;
        }
        else if (userStorePermissions && userStorePermissions.length > 0) {
          let store = userStorePermissions.filter(item => item.id === resourceId)[0];
          if (store) {
            return store.permissions.some((item: any) => value.indexOf(item) >= 0);
          }
          else {
            return false;
          }
        }
        else {
          return false;
        }
      }
      else if (resourceTypeId && resourceId && userInfo && resourceTypeId===AccessLevel.Department && resourceId > 0) {
        let userdeparmentPermissions: any[] = userInfo.privileges.departments;
       if (userdeparmentPermissions && userdeparmentPermissions.length > 0) {
          let department = userdeparmentPermissions.filter(item => item.id === resourceId)[0];
          if (department) {
            return department.permissions.some((item: any) => value.indexOf(item) >= 0);
          }
          else {
            return false;
          }
        }
        else {
          return false;
        }
      } else if(resourceTypeId && userInfo && userInfo.privileges && resourceTypeId===AccessLevel.Customer_Service){
        const userCSPermissions: any[] = userInfo.privileges.customerService;
        if (userCSPermissions && userCSPermissions.length > 0 && userCSPermissions.some(item => value.indexOf(item) >= 0)) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        if (userInfo && userInfo.privileges) {
          let userAccountPermissions: any[] = userInfo.privileges.account;
          if (userAccountPermissions && userAccountPermissions.length > 0 && userAccountPermissions.some(item => value.indexOf(item) >= 0)) {
            return true;
          }
          else {
            return false;
          }
        }
      }
    }
    else {
      return false;
    }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/pipes/authorization-extension.pipe.ts